<ami-dialog-message [setting]="message"></ami-dialog-message>
<div class="card h-full">
  <ami-head [settings]="settingsAmiHead"> </ami-head>
  <ami-table-actions
    [settings]="table.settings"
    [data]="table.data"
    [actions]="table.actions"
    (action)="onReciveAction($event)"
  ></ami-table-actions>
</div>
